import type { ConversationMessage } from '../../store/converse/types';

export const getTotalSources = (message: ConversationMessage): number => {
    return message?.sources?.length ?? 0;
};
